import React, { useState, useEffect } from "react";
import Select from "react-select";
import { State } from "../../common/selectOption/selectOption";
import { useAddUserMutation, useUpdateUserMutation } from "../../redux/api/userApi";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Modal } from "bootstrap";

const userSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  userName: Yup.string().required('Username is required'),
  mobile: Yup.string()
  .required('Mobile Number is required')
  .matches(/^[0-9]{10}$/, 'Mobile Number must be 10 digits'),
  // email: Yup.string()
  //   .email('Invalid email address'),
  password: Yup.string()
    .when('isEdit', (isEdit, schema) => {
      return isEdit ? schema : schema.required("Password is required").min(8, "Password must be at least 8 characters");
    }),
  confirmPassword: Yup.string()
    .when('isEdit', (isEdit, schema) => {
      return isEdit ? schema : schema
        .required("Please confirm your password")
        .oneOf([Yup.ref('password'), null], 'Passwords must match');
    }),
  address: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  postalCode: Yup.string(),
  status: Yup.boolean().default(true),
  isEdit: Yup.boolean() // Explicitly define isEdit in schema
});

const UserModal = ({ isEdit = false, userData = null, onSuccess = () => {} }) => {
  console.log("checking edit", isEdit,  userData?.firstName, onSuccess);
  const [addUser] = useAddUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      userName: '',
      // email: '',
      mobile: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      password: '',
      confirmPassword: '',
      status: true,
      isEdit: isEdit
    },
    validationSchema: userSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => { 
          try {
            const promise = isEdit && userData
              ? updateUser({ id: userData._id, ...values }).unwrap()
              : addUser(values).unwrap();
        
            await toast.promise(promise, {
              loading: isEdit ? 'Updating user...' : 'Adding user...',
              success: () => {
                onSuccess();
                resetForm();
            
                return isEdit ? 'User updated!' : 'User added!';
              },
              error: (error) => {
                console.error('Error:', error.data || error);
                return error.data?.message || 'Operation failed';
              }
            });
        
          } finally {
            setSubmitting(false);
                
           
          }
          document.querySelector('#add-user [data-bs-dismiss="modal"]')?.click();
        }
  });

  useEffect(() => {
    if (isEdit && userData) {
      formik.setValues({
        firstName: userData?.firstName || '',
        lastName: userData?.lastName || '',
        userName: userData?.userName || '',
        mobile: userData?.mobile || '',
        address: userData?.address || '',
        city: userData?.city || '',
        state: userData?.state || '',
        postalCode: userData?.postalCode || '',
        password: userData?.password,
        confirmPassword: '',
        status: userData.status !== undefined ? userData?.status : true,
        // isEdit: true
      });
    }else if (!isEdit) {
      formik.resetForm();
    }
  }, [isEdit, userData]);

  const handleStatusChange = (e) => {
    formik.setFieldValue('status', e.target.checked);
  };

 
  return (
    <div className="modal fade" id="add-user" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="page-title">
              <h4>{isEdit ? 'Edit User' : 'Add User'}</h4>
            </div>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => formik.resetForm()}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">
                      First Name <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      className={`form-control ${formik.touched.firstName && formik.errors.firstName ? 'is-invalid' : ''}`}
                      name="firstName"
                      value={formik?.values?.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.firstName && formik.errors.firstName && (
                      <div className="invalid-feedback">{formik.errors.firstName}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Last Name <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      className={`form-control ${formik.touched.lastName && formik.errors.lastName ? 'is-invalid' : ''}`}
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.lastName && formik.errors.lastName && (
                      <div className="invalid-feedback">{formik.errors.lastName}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Username <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      className={`form-control ${formik.touched.userName && formik.errors.userName ? 'is-invalid' : ''}`}
                      name="userName"
                      value={formik.values.userName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.userName && formik.errors.userName && (
                      <div className="invalid-feedback">{formik.errors.userName}</div>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="email" 
                      className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="invalid-feedback">{formik.errors.email}</div>
                    )}
                  </div>
                </div> */}
                {!isEdit && (
                  <>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input 
                            type={showPassword ? "text" : "password"} 
                            className={`form-control ${formik.touched.password && formik.errors.password ? 'is-invalid' : ''}`}
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <button 
                            className="btn btn-outline-secondary" 
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? 'Hide' : 'Show'}
                          </button>
                        </div>
                        {formik.touched.password && formik.errors.password && (
                          <div className="invalid-feedback">{formik.errors.password}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">
                          Confirm Password <span className="text-danger">*</span>
                        </label>
                        <input 
                          type={showPassword ? "text" : "password"} 
                          className={`form-control ${formik.touched.confirmPassword && formik.errors.confirmPassword ? 'is-invalid' : ''}`}
                          name="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                          <div className="invalid-feedback">{formik.errors.confirmPassword}</div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Mobile <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      className={`form-control ${formik.touched.mobile && formik.errors.mobile ? 'is-invalid' : ''}`}
                      name="mobile"
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                      <div className="invalid-feedback">{formik.errors.mobile}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <input 
                      type="text" 
                      className={`form-control ${formik.touched.address && formik.errors.address ? 'is-invalid' : ''}`}
                      name="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">City</label>
                    <input 
                      type="text" 
                      className="form-control"
                      name="city"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">State</label>
                    <Select
                      options={State}
                      classNamePrefix="select"
                      name="state"
                      value={State.find(option => option.value === formik.values.state) || null}
                      onChange={(option) => formik.setFieldValue('state', option?.value || '')}
                      onBlur={formik.handleBlur}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <label className="form-label">Postal Code</label>
                    <input 
                      type="text" 
                      className="form-control"
                      name="postalCode"
                      value={formik.values.postalCode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-0">
                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                      <span className="status-label">Status</span>
                      <input
                        type="checkbox"
                        id="user-status"
                        className="check"
                        checked={formik.values.status}
                        onChange={handleStatusChange}
                      />
                      <label htmlFor="user-status" className="checktoggle mb-0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                data-bs-dismiss="modal"
                onClick={() => formik.resetForm()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary fs-13 fw-medium p-2 px-3"
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {formik.isSubmitting ? 'Processing...' : isEdit ? 'Update User' : 'Add User'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserModal;